import React, { useCallback } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle
} from "@fluentui/react-components";
import { FormattedMessage, useIntl } from "react-intl";
import { Dismiss24Regular } from "@fluentui/react-icons";

export function DeleteAvatarDialog({ avatar, open, onOpenChange, onSave }) {
  const intl = useIntl();

  const confirmDelete = useCallback(async () => {
    try {
      await onSave?.();
    } catch {
      // The mutation owner reports the error; leaving the dialog open allows retry.
    }
  }, [onSave]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                aria-label={intl.formatMessage({ id: "room-settings-sidebar.close-button", defaultMessage: "Close" })}
                icon={<Dismiss24Regular />}
                onClick={() => onOpenChange(null, { open: false })}
              />
            }
          >
            <FormattedMessage id="avatar-editor.delete-avatar" defaultMessage="Delete avatar" />
          </DialogTitle>
          <DialogContent>
            <FormattedMessage
              id="avatar-editor.delete-avatar.confirmation-prompt"
              defaultMessage="Are you sure you want to delete the avatar: {avatarName}?"
              values={{ avatarName: avatar?.name }}
            />
          </DialogContent>
          <DialogActions>
            <Button appearance="outline" onClick={() => onOpenChange(null, { open: false })}>
              <FormattedMessage id="avatar-editor.delete-avatar.cancel" defaultMessage="No" />
            </Button>
            <Button appearance="primary" onClick={confirmDelete}>
              <FormattedMessage id="avatar-editor.delete-avatar.confirm" defaultMessage="Yes" />
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

DeleteAvatarDialog.propTypes = {
  avatar: PropTypes.shape({
    id: PropTypes.string,
    avatar_id: PropTypes.string,
    name: PropTypes.string.isRequired
  }).isRequired,
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onSave: PropTypes.func
};
